import { render, staticRenderFns } from "./CmgRewardExtrasGroupCampaignDetailModal.vue?vue&type=template&id=5b96e4f1&scoped=true&lang=pug"
import script from "./cmg-reward-extras-group-campaign-detail-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-reward-extras-group-campaign-detail-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRewardExtrasGroupCampaignDetailModal.vue?vue&type=style&index=0&id=5b96e4f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b96e4f1",
  null
  
)

export default component.exports